/**
 * Share Post Block - Interactivity API view script.
 * Handles: popup toggle, close on outside click, copy link with feedback.
 */

import { store, getContext, getElement } from '@wordpress/interactivity';

store( 'brandy/share-post', {
	state: {
		get isOpen() {
			return getContext().isOpen;
		},
		get copyText() {
			return getContext().copyText;
		},
	},
	actions: {
		toggle() {
			const ctx = getContext();
			ctx.isOpen = ! ctx.isOpen;
		},
		async copyLink() {
			const ctx = getContext();
			const url = window.location.href;
			try {
				await navigator.clipboard.writeText( url );
			} catch {
				// Fallback for browsers without Clipboard API.
				const textarea = document.createElement( 'textarea' );
				textarea.value = url;
				textarea.style.position = 'fixed';
				textarea.style.opacity = '0';
				document.body.appendChild( textarea );
				textarea.select();
				document.execCommand( 'copy' );
				document.body.removeChild( textarea );
			}
			const original = ctx.originalCopyText;
			ctx.copyText = 'Copied!';
			setTimeout( () => {
				ctx.copyText = original;
			}, 2000 );
		},
	},
	callbacks: {
		init() {
			const ctx = getContext();
			const { ref } = getElement();

			// Close popup when user clicks outside the block element.
			const handleOutsideClick = ( event ) => {
				if ( ctx.isOpen && ref && ! ref.contains( event.target ) ) {
					ctx.isOpen = false;
				}
			};

			// Capture phase fires before inner handlers, avoids same-click conflicts.
			document.addEventListener( 'click', handleOutsideClick, true );

			return () => {
				document.removeEventListener( 'click', handleOutsideClick, true );
			};
		},
	},
} );
